// Resale prices (Amazon via Keepa + eBay sold) on the product detail modal.
// Mirrors pinto's resale.* keys; merged in parity/index.ts.
export const resaleEn = {
  resale: {
    section: "What it sells for",
    amazon: "Amazon",
    ebay: "eBay",
    amazon_buybox: "Buy Box price",
    amazon_avg90: "90-day average",
    amazon_monthly: "~{{n}} sold/mo",
    ebay_sold: "Median of {{count}} sold",
    ebay_sold_range: "Median of {{count}} sold · {{range}}",
    ebay_median: "Median sold price",
    no_amazon: "Not sold on Amazon",
    no_ebay: "No recent eBay sales",
    no_barcode: "No barcode to match",
    under_20: "Under $20 retail",
    skipped: "Not checked",
    budget: "Check again later",
    unavailable: "Unavailable",
    view_amazon: "View on Amazon",
    search_amazon: "Search Amazon",
    view_ebay: "See sold listings",
    recent_sales: "Recent eBay sales ({{count}})",
    empty: "No resale prices for this item yet",
    footnote: "Real sold data · updated {{when}}",
    locked: "See what this sells for on Amazon and eBay",
    pro: "Pro",
    just_now: "just now",
    time_minutes: "{{n}}m ago",
    time_hours: "{{n}}h ago",
    time_days: "{{n}}d ago",
  },
};

export const resaleEs = {
  resale: {
    section: "En cuánto se vende",
    amazon: "Amazon",
    ebay: "eBay",
    amazon_buybox: "Precio del Buy Box",
    amazon_avg90: "Promedio de 90 días",
    amazon_monthly: "~{{n}} vendidos/mes",
    ebay_sold: "Mediana de {{count}} vendidos",
    ebay_sold_range: "Mediana de {{count}} vendidos · {{range}}",
    ebay_median: "Mediana de venta",
    no_amazon: "No se vende en Amazon",
    no_ebay: "Sin ventas recientes en eBay",
    no_barcode: "Sin código de barras",
    under_20: "Cuesta menos de $20",
    skipped: "No revisado",
    budget: "Vuelve a revisar más tarde",
    unavailable: "No disponible",
    view_amazon: "Ver en Amazon",
    search_amazon: "Buscar en Amazon",
    view_ebay: "Ver vendidos",
    recent_sales: "Ventas recientes en eBay ({{count}})",
    empty: "Aún no hay precios de reventa",
    footnote: "Datos reales de ventas · actualizado {{when}}",
    locked: "Mira en cuánto se vende en Amazon y eBay",
    pro: "Pro",
    just_now: "ahora mismo",
    time_minutes: "hace {{n}}m",
    time_hours: "hace {{n}}h",
    time_days: "hace {{n}}d",
  },
};
